"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ResolveForcedVars = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _fill = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/fill"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _classes = require("../classes");
var _api = require("../api");
var ForcedMarker = /*#__PURE__*/function () {
  function ForcedMarker() {
    (0, _classCallCheck2["default"])(this, ForcedMarker);
    this.list = [];
  }
  (0, _createClass2["default"])(ForcedMarker, [{
    key: "length",
    get: function get() {
      return this.list.length;
    }
  }, {
    key: "unresolved",
    get: function get() {
      var _context;
      return (0, _filter["default"])(_context = this.list).call(_context, function (m) {
        return !m.solved;
      }).length;
    }
  }, {
    key: "push",
    value: function push(el) {
      var _context2;
      var found = (0, _find["default"])(_context2 = this.list).call(_context2, function (v) {
        return el.variant.cod == v.variant.cod;
      });
      if (!found) {
        this.list.push(el);
      }
    }
  }, {
    key: "fill",
    value: function fill(vars) {
      var _this = this;
      (0, _forEach["default"])(vars).call(vars, function (v) {
        _this.push({
          variant: v,
          solved: false
        });
      });
    }
  }, {
    key: "getUnresolved",
    value: function getUnresolved() {
      var _context3;
      return (0, _find["default"])(_context3 = this.list).call(_context3, function (m) {
        return !m.solved;
      });
    }
  }, {
    key: "empty",
    value: function empty() {
      this.list = [];
    }
  }]);
  return ForcedMarker;
}();
var ResolveForcedVars = /*#__PURE__*/function () {
  function ResolveForcedVars(modalRef) {
    (0, _classCallCheck2["default"])(this, ResolveForcedVars);
    this.modal = modalRef;
  }
  (0, _createClass2["default"])(ResolveForcedVars, [{
    key: "resolve",
    value: function () {
      var _resolve = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(rule, catalog) {
        var cpRule, variants, marker;
        return _regenerator["default"].wrap(function _callee$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (rule instanceof _classes.Rule) {
                _context4.next = 2;
                break;
              }
              throw 'rule is not an instance of Rule';
            case 2:
              if (catalog) {
                _context4.next = 4;
                break;
              }
              throw 'Catalog is not defined';
            case 4:
              cpRule = new _classes.Rule(rule);
              variants = rule.getForced();
              marker = new ForcedMarker();
              (0, _fill["default"])(marker).call(marker, variants);
              return _context4.abrupt("return", this.resolveVarMarker(marker, cpRule, catalog));
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee, this);
      }));
      function resolve(_x, _x2) {
        return _resolve.apply(this, arguments);
      }
      return resolve;
    }()
  }, {
    key: "subResolve",
    value: function () {
      var _subResolve = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(mainRule, subRule, catalog) {
        var cpRule, variants, mainVariants, filterVars, marker;
        return _regenerator["default"].wrap(function _callee2$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (mainRule instanceof _classes.Rule) {
                _context5.next = 2;
                break;
              }
              throw 'mainRule is not an instance of Rule';
            case 2:
              if (subRule instanceof _classes.Rule) {
                _context5.next = 4;
                break;
              }
              throw 'subRule is not an instance of Rule';
            case 4:
              if (catalog) {
                _context5.next = 6;
                break;
              }
              throw 'Catalog is not defined';
            case 6:
              cpRule = new _classes.Rule(subRule);
              variants = subRule.getForced();
              mainVariants = mainRule.getForced();
              filterVars = (0, _filter["default"])(variants).call(variants, function (r) {
                return !(0, _find["default"])(mainVariants).call(mainVariants, function (rr) {
                  return rr.cod === r.cod;
                });
              });
              marker = new ForcedMarker();
              (0, _fill["default"])(marker).call(marker, filterVars);
              return _context5.abrupt("return", this.subResolveVarMarker(marker, mainRule, cpRule, catalog));
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee2, this);
      }));
      function subResolve(_x3, _x4, _x5) {
        return _subResolve.apply(this, arguments);
      }
      return subResolve;
    }()
  }, {
    key: "resolveVariants",
    value: function () {
      var _resolveVariants = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(array, rule, catalog) {
        var _this2 = this;
        return _regenerator["default"].wrap(function _callee3$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              console.warn("Method ResolveForcedVars.resolveVariants is deprecated");
              return _context8.abrupt("return", new _promise["default"](function (resolve, reject) {
                if (array.length > 0) {
                  var variant = array.shift();
                  _this2.modal.selectVariant(variant, rule, catalog).then(function (data) {
                    var newVal = data.cod + '=' + data.value;
                    var params = {
                      model: rule.model || '',
                      neutro: rule.neutro || '<',
                      item: rule.item || '',
                      cModel: rule.cModel || '',
                      reg: rule.reg || ''
                    };
                    _api.CrulesAPI.ruleSetParam(catalog, newVal, params, function (res) {
                      var resRule;
                      try {
                        var _context6;
                        resRule = new _classes.Rule(res);
                        var nestedForcedVars = (0, _filter["default"])(_context6 = resRule.rows).call(_context6, function (r) {
                          var _context7;
                          return r.obbligate && !(0, _find["default"])(_context7 = rule.rows).call(_context7, function (rr) {
                            return rr.cod === r.cod;
                          });
                        });
                        if (nestedForcedVars.length) {
                          var nestedResolver = new ResolveForcedVars(_this2.modal);
                          nestedResolver.resolveVariants(nestedForcedVars, resRule, catalog).then(function (newRule) {
                            rule.setVariantData(newRule);
                            _this2.resolveVariants(array, rule, catalog).then(resolve);
                          });
                        } else {
                          rule.setVariantData(res);
                          _this2.resolveVariants(array, rule, catalog).then(resolve);
                        }
                      } catch (e) {
                        console.warn(e);
                        rule.setVariantData(res);
                        _this2.resolveVariants(array, rule, catalog).then(resolve);
                      }
                    });
                  })["catch"](reject);
                } else {
                  resolve(rule);
                }
              }));
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee3);
      }));
      function resolveVariants(_x6, _x7, _x8) {
        return _resolveVariants.apply(this, arguments);
      }
      return resolveVariants;
    }()
  }, {
    key: "resolveVarMarker",
    value: function () {
      var _resolveVarMarker = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(marker, rule, catalog) {
        var _this3 = this;
        return _regenerator["default"].wrap(function _callee4$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", new _promise["default"](function (resolve, reject) {
                if (marker.unresolved > 0) {
                  var markItem = marker.getUnresolved();
                  var variant = markItem.variant;
                  _this3.modal.selectVariant(variant, rule, catalog).then(function (data) {
                    var newVal = data.cod + '=' + data.value;
                    var params = {
                      model: rule.model || '',
                      neutro: rule.neutro || '<',
                      item: rule.item || '',
                      cModel: rule.cModel || '',
                      reg: rule.reg || ''
                    };
                    _api.CrulesAPI.ruleSetParam(catalog, newVal, params, function (res) {
                      markItem.solved = true;
                      rule.setVariantData(res);
                      var newForcedVars = rule.getForced();
                      (0, _forEach["default"])(newForcedVars).call(newForcedVars, function (v) {
                        marker.push({
                          variant: v,
                          solved: false
                        });
                      });
                      _this3.resolveVarMarker(marker, rule, catalog).then(resolve);
                    });
                  })["catch"](reject);
                } else {
                  resolve(rule);
                }
              }));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee4);
      }));
      function resolveVarMarker(_x9, _x10, _x11) {
        return _resolveVarMarker.apply(this, arguments);
      }
      return resolveVarMarker;
    }()
  }, {
    key: "subResolveVarMarker",
    value: function () {
      var _subResolveVarMarker = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(marker, mainRule, subRule, catalog) {
        var _this4 = this;
        return _regenerator["default"].wrap(function _callee5$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", new _promise["default"](function (resolve, reject) {
                if (marker.unresolved > 0) {
                  var markItem = marker.getUnresolved();
                  var variant = markItem.variant;
                  _this4.modal.selectVariant(variant, subRule, catalog).then(function (data) {
                    var newVal = data.cod + '=' + data.value;
                    var params = {
                      model: subRule.model || '',
                      neutro: subRule.neutro || '<',
                      item: subRule.item || '',
                      cModel: subRule.cModel || '',
                      reg: subRule.reg || ''
                    };
                    _api.CrulesAPI.ruleSetParam(catalog, newVal, params, function (res) {
                      markItem.solved = true;
                      subRule.setVariantData(res);
                      var newForcedVars = subRule.getForced();
                      var mainVariants = mainRule.getForced();
                      var filterVars = (0, _filter["default"])(newForcedVars).call(newForcedVars, function (r) {
                        return !(0, _find["default"])(mainVariants).call(mainVariants, function (rr) {
                          return rr.cod === r.cod;
                        });
                      });
                      (0, _fill["default"])(marker).call(marker, filterVars);
                      _this4.subResolveVarMarker(marker, mainRule, subRule, catalog).then(resolve);
                    });
                  })["catch"](reject);
                } else {
                  resolve(subRule);
                }
              }));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee5);
      }));
      function subResolveVarMarker(_x12, _x13, _x14, _x15) {
        return _subResolveVarMarker.apply(this, arguments);
      }
      return subResolveVarMarker;
    }()
  }]);
  return ResolveForcedVars;
}();
exports.ResolveForcedVars = ResolveForcedVars;
//# sourceMappingURL=ResolveForcedVars.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/controllers/ResolveForcedVars.js
// module id = 1248
// module chunks = 142